module.exports = __webpack_public_path__ + "img/3icon-选中.602ec2d2.png";